<template>
  <div class="m-t-5 m-b-10">
    <a
      :class="{ 'line-through faded': file.isRemoved, 'contract-form-file-link': true }"
      :href="filePath"
      target="_blank"
      download
      @click="handleIsReviewed"
    >
      <i class="fa fa-paperclip" />
      {{ file.name }}
      <span class="c-gray m-l-5 m-r-5">{{ file.human_readable_size }}</span>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsLabel
        v-if="needsReview && showChanges"
        :success="!file.isRemoved"
        :error="file.isRemoved"
        subtle
      >
        {{ file.isRemoved ? 'Removed' : 'Newly added' }}
      </WdsLabel>
    </a>
    <template v-if="editMode">
      <i
        v-if="!file.isRemoved"
        class="zmdi zmdi-delete c-gray m-l-10 pointer"
        @click="$emit('toggleFileDeletion')"
      />
      <a v-if="file.isRemoved" class="pointer small m-l-10" @click="$emit('toggleFileDeletion')">
        {{ $t('Undo') }}
      </a>
    </template>
    <small
      v-if="isViewingAsCompany && hasAutoIncludeTag && !file.isRemoved"
      v-tooltip:top="$t('Automatically added to your contracts')"
      class="c-gray m-l-5"
    >
      {{ $t('Default on contracts') }}
    </small>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <ProvideApiFilebank
      v-if="isViewingAsCompany"
      v-slot="{ attachTag, detachTag }"
      @tags-attached="handleTagsAttached"
      @tags-detached="handleTagsDetached"
    >
      <transition name="fade">
        <div v-if="shouldPromptForTagRemoval" class="m-t-5 m-l-10 f-12 c-fuscia">
          {{ $t('Also stop adding file to future contracts?') }}
          <a href="#" @click="detachTag(file.localId, ['Default on contracts'])">Yes</a>
          |
          <a href="#" @click="disableTagRemovalPrompt = true">No</a>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="shouldPromptForTagAddition" class="m-t-5 m-l-10 f-12 c-fuscia">
          {{ $t('Include file on all future contracts?') }}
          <a href="#" @click="attachTag(file.localId, ['Default on contracts'])">Yes</a>
          |
          <a href="#" @click="disableTagAdditionPrompt = true">No</a>
        </div>
      </transition>
    </ProvideApiFilebank>
  </div>
</template>

<script>
export default {
  props: {
    editMode: { type: Boolean, default: false },
    isViewingAsCompany: { type: Boolean, default: false },
    needsReview: { type: Boolean, default: false },
    filePath: { type: String, default: '' },
    file: { type: Object, default: () => {} },
    showChanges: { type: Boolean, default: false },
  },
  data() {
    return {
      disableTagRemovalPrompt: false,
      disableTagAdditionPrompt: false,
      tagHasBeenDetached: false,
      hasAutoIncludeTag: this.initiallyHasTag(),
    }
  },
  computed: {
    shouldPromptForTagAddition() {
      return (
        !this.hasAutoIncludeTag &&
        (this.file.isRecentlyAdded || this.tagHasBeenDetached) &&
        !this.file.isRemoved &&
        !this.disableTagAdditionPrompt
      )
    },
    shouldPromptForTagRemoval() {
      return this.hasAutoIncludeTag && this.file.isRemoved && !this.disableTagRemovalPrompt
    },
  },
  methods: {
    handleIsReviewed() {
      // eslint-disable-next-line vue/no-mutating-props
      this.file.isReviewed = true
    },
    handleTagsAttached() {
      this.hasAutoIncludeTag = true
    },
    handleTagsDetached() {
      this.hasAutoIncludeTag = false
      this.tagHasBeenDetached = true
    },
    initiallyHasTag() {
      return this.file.applied_tags?.map((t) => t.tag.name).includes('Default on contracts')
    },
  },
}
</script>

<style scoped>
.line-through {
  text-decoration: line-through;
}
a {
  padding: 5px;
}
a:hover {
  background-color: #f3f0ff;
  border-radius: 4px;
}
</style>
